import { render, staticRenderFns } from "./contractDetails.vue?vue&type=template&id=18928cd8"
import script from "./contractDetails.vue?vue&type=script&lang=js"
export * from "./contractDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports